function getSpinnerVariant(variant) {
    switch (variant) {
        case 'primary':
        case 'inverse-ghost':
            return 'inverse';
        default:
            return 'secondary';
    }
}

export { getSpinnerVariant };
